module.exports = __webpack_public_path__ + "4fde2ed612a6a2f9ff03069a579a3bac.svg";